'use strict';

const mapScripts = $ => {
	const simplemaps = simplemaps_usmap;
	const locations = window.mapLocations;
	const stateData = window.stateData;
	const $display = $( '#interactive-display' );
	const $form = $( '#filter-form' );
	const $stateFilter = $( '#state-select' );
	const $districtFilter = $( '#district-select' );
	const $includeStateFilter = $( '#includeState' );
	const $includeNationalFilter = $( '#includeNational' );

	const isStateSelected = ( stateVal ) => {
		if ( stateVal !== '' && stateVal !== 'nation' ) {
			return true;
		}

		return false;
	};

	const getFeed = ( filters ) => {
		const { pageNum, state, district, types, public_private, issues, includeState, includeNational } = filters;

		return new Promise( ( resolve, reject ) => {
			$.ajax( {
				type: 'GET',
				url: '/wp-json/wp/v2/regetcards',
				data: {
					action: 'rest_re_get_cards',
					school_page: pageNum,
					state,
					district,
					types,
					public_private,
					issues,
					includeState,
					includeNational,
					is_map: true,
				},
				success: ( data ) => {
					resolve( data );
				},
				error: ( err ) => {
					reject( err );
				}
			} );
		} );
	};

	const updateDistrictFilter = () => {
		const districts = window.schoolDistricts;
		const stateVal = $stateFilter.val();

		$districtFilter.children( 'option:not(:first)' ).remove();

		// Add options if state is selected
		if ( isStateSelected( stateVal ) ) {
			const stateDistricts = districts[ stateVal ];

			$.each( stateDistricts, ( key, value ) => {
				const option = '<option value="' + value.term_id + '">' + value.name + '</option>';
				$districtFilter.append( option );
			} );

			return $districtFilter.prop( 'disabled', false );
		}

		$districtFilter.prop( 'disabled', true );
	};

	const updateStateDataDisplay = ( state, district = null ) => {
		const data = stateData[ state.toLowerCase() ];
		const needToResize = $display.hasClass( 'has-data' ) ? false : true;

		if ( isStateSelected( state ) ) {
			if ( needToResize ) {
				$( '.delay-visibility' ).css( { opacity: 0 } );
				$display.addClass( 'has-data' );
				window.dispatchEvent( new Event( 'resize' ) );

				setTimeout( function() {
					$( '.delay-visibility' ).css( { opacity: 1 } );
				}, 300 );
			}

			if (district) {
				$( '#data-display-name' ).text( district.name );
				if (district.page_link) {
					$( '#data-panel .data-list' ).after( '<a class="btn btn-primary" href="' + district.page_link + '" >Learn More</a>');
				} else {
					$( '#data-panel .btn-primary' ).remove();
				}
			} else {
				$( '#data-display-name' ).text( data.name );
				$( '#data-panel .btn-primary' ).remove();
			}

			$( '#data-orgs' ).text( data.orgs );
			$( '#data-incidents' ).text( data.incidents );
			$( '#data-foias' ).text( data.foias );
		} else {
			$display.removeClass( 'has-data' );
			window.dispatchEvent( new Event( 'resize' ) );
		}
	};

	const onMapBackClick = () => {
		// Update filters
		$stateFilter.val( '' );
		updateDistrictFilter();

		// Update display
		updateStateDataDisplay( '' );

		window.dispatchEvent( new Event( 'resize' ) );

		updateFeed();
	};

	const onMapClick = ( stateId, districtId = null ) => {
		const district = districtId ? locations[ districtId ] : null;
		const state = stateId ? stateId.toLowerCase() : district.state;

		if ( district ) {
			district.id = districtId;
		}

		updateMap( state, district );
		updateFeed();
	};

	const onFormSubmit = () => {
		//console.log('real form submit');
		const state = $stateFilter.val();

		if ( ! isStateSelected( state ) ) {
			// onMapBackClick(); // redundant
			simplemaps.back();
			return;
		} else {
			const districtId = $districtFilter.val();
			let district = null;

			if ( districtId ) {
				district = locations[ districtId ];
				district.id = districtId;
			}

			updateMap( state, district );
			updateFeed();
		}
	};

	const updateMap = ( state, district ) => {
		const needToResize = $display.hasClass( 'has-data' ) ? false : true;

		// Update filters
		$stateFilter.val( state.toLowerCase() );
		updateDistrictFilter();

		if ( district ) {
			$districtFilter.val( district.id );
			updateStateDataDisplay( state, district )
		} else {
			updateStateDataDisplay( state )
		}

		// Map update
		if ( needToResize ) {
			setTimeout( function() {
				simplemaps.state_zoom( state.toUpperCase() );
			}, 300 );
		} else {
			simplemaps.state_zoom( state.toUpperCase() );
		}
	};

	const updateFeed = ( args = {} ) => {
		// Default settings
		const pageNum = 'pageNum' in args ? args.pageNum : 1;
		const scrollToTop = 'scrollToTop' in args ? args.scrollToTop : false;

		// Feed markup
		const $feed = $( '#school-feed' );
		const spinner = `
					<div class="spinner-wrapper" id="spinner" >
					  <div class="spinner-border" role="status">
						<span class="sr-only">Loading...</span>
					  </div>
					</div>`;
		const $spinner = $( spinner );
		const mapBlock = `<div class="map-block" id="map-block"></div>`;

		// Get values
		const stateVal = $stateFilter.val();
		const districtVal = $districtFilter.val();
		const includeState = $includeStateFilter.is( ':checked' ) ? true : false;
		const includeNational = $includeNationalFilter.is( ':checked' ) ? true : false;
		const types = [];
		const public_private = [];
		const issues = [];

		$.each( $( 'input[name=type]:checked' ), function() {
			types.push( $( this ).val() );
		} );

		console.log('log types');
		console.log(types);

		$.each( $( 'input[name=public_private]:checked' ), function() {
			public_private.push( $(this).val() );
		});

		$.each( $( 'input[name=issue]:checked' ), function() {
			issues.push( $( this ).val() );
		} );

		// Update URL
		window.history.pushState( '', '', '/map/?state-filter=' + stateVal + '&district-filter=' + districtVal + '&types-filter=' + types + '&issues-filter=' + issues + '&public-private-filter=' + public_private );

		// If using pagination keep spinner at bottom of page before scrolling up
		if ( scrollToTop ) {
			$spinner.css( {
				position: 'absolute',
				bottom: 0
			} );

			$feed.css( {
				minHeight: $( '.card-feed' ).height(),
				position: 'relative'
			} );
		}

		$feed.html( $spinner );
		$( '#map ').css('opacity', 0.5);
		$( '#map' ).append(mapBlock);

		// Get data
		const filters = {
			pageNum,
			state: stateVal,
			district: districtVal,
			types,
			public_private,
			issues,
			includeState,
			includeNational
		};

		getFeed( filters )
			.then( data => {
				// Add feed markup
				const html = ! $.trim( data ) ?
					'<div class="no-results-wrapper"><p>No Results Found</p></div>' :
					data;

				$feed.html( html );
				$( '#map ').css('opacity', 1);
				$( '#map-block' ).remove();

				// Scroll up if pagination
				if ( scrollToTop ) {
					$( 'html, body' ).animate( {
						scrollTop: $feed.offset().top
					}, 500 );

					$feed.removeAttr( 'style' );
				}
			} );
	};

	return {
		init() {
			// Load map
			simplemaps.hooks.ready = () => {
				simplemaps.load();
			};

			this.bind();
		},
		bind() {
			// Map state on click
			simplemaps.hooks.click_state = ( id ) => {
				onMapClick( id );
			};

			// Map pin on click
			simplemaps.hooks.click_location = ( id ) => {
				onMapClick( null, id );
			};

			// Map back button
			simplemaps.hooks.back = () => {
				onMapBackClick();
			};

			// State filter on change
			$stateFilter.on( 'change', () => {
				updateDistrictFilter();
			} );

			// Update feed on submit
			$form.on( 'submit', ( e ) => {
				e.preventDefault();
				onFormSubmit();
			} );

			// Update feed on pagination
			$( document ).on( 'click', '.pagination-link', ( e ) => {
				e.preventDefault();

				const args = {
					pageNum: $( e.currentTarget ).attr( 'data-school-page' ),
					scrollToTop: true
				};

				updateFeed( args );
			} );

			// Update feed on mobile pagination
			$( document ).on( 'change', '.pagination-select', ( e ) => {
				e.preventDefault();

				const args = {
					pageNum: $( e.currentTarget ).children( ':selected' ).attr( 'data-school-page' ),
					scrollToTop: true
				};

				updateFeed( args );
			} );

			$( document ).ready( function() {
				const district = window.selectedDistrict ? locations[ window.selectedDistrict ] : null;

				if ( ! district ) {
					return;
				}

				const state = window.selectedState ? window.selectedState.toLowerCase() : district.state;

				if ( district ) {
					district.id = window.selectedDistrict;
				}

				setTimeout( function() {
					updateMap( state, district );
				}, 500 );
			} );
		}
	};
};

mapScripts( jQuery ).init();
